import React from 'react';

import { InitialsWrapper, StyledAvatar } from './Avatar.styles';
import type { AvatarProps } from './Avatar.types';
import { getAvatarColor, getInitials, hexToRgba } from './Avatar.utils';

/**
 * Primitive Avatar component with deterministic colors
 * Always renders as circular variant with consistent styling
 */
export const Avatar: React.FC<AvatarProps> = ({
  id,
  firstName,
  lastName,
  src,
  children,
  sx,
  ...props
}) => {
  // Generate initials if no src or children provided
  const initials = !src && !children ? getInitials(firstName, lastName) : undefined;

  // Generate deterministic color if ID provided
  const avatarColor = id && !src ? getAvatarColor(id) : undefined;

  // Combine sx props - apply color as text color with light background
  const combinedSx = {
    ...(avatarColor
      ? {
          color: avatarColor,
          backgroundColor: hexToRgba(avatarColor, 0.15), // 15% opacity
        }
      : {}),
    // eslint-disable-next-line @typescript-eslint/no-misused-spread
    ...sx,
  };

  return (
    <StyledAvatar
      variant="circular" // Always use circular internally
      src={src}
      sx={combinedSx}
      {...props}
    >
      {children || (initials ? <InitialsWrapper>{initials}</InitialsWrapper> : undefined)}
    </StyledAvatar>
  );
};
